export default __webpack_public_path__ + "static/media/gallery-wip-pommel_07.5af02a06.jpg";